const getFormattedDurationSecs = (milliseconds, padStart) => {
  let ms = parseInt((milliseconds % 1000) / 10),
    s = parseInt(milliseconds / 1000);
  if (padStart) {
    s = s < 10 ? '<span class="timer__leading-zeros">00</span>' + s : s;
    s = s >= 10 && s < 100 ? '<span class="timer__leading-zeros">0</span>' + s : s;
  }
  ms = ms < 10 ? '0' + ms : ms;
  return `${s}.${ms}`;
};

export default getFormattedDurationSecs;
